/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
define(['ext', 'ol', 'hvx/modules/CoreModule'], function(Ext, ol, Core){
	
	return Ext.define('map.DescriptionDetailRenderer', {
		
		constructor: function() {
		},
		
		render: function(container, feature) {
		
			if(feature.get('type') == 'incident'){
			
				container.add( new Ext.form.field.Display({
					fieldLabel: 'Incident Name',
					value: feature.get('incidentname')
				}));
				
				var desc = feature.get('description');
				
				if(desc) {
					container.add( new Ext.form.field.Display({
						fieldLabel: 'Description',
						value: desc
					}));
				}
				
				container.add( new Ext.button.Button({
					text: 'Join Incident',
					margin: '0 0 0 150',
					handler: function() {
								var parent = this.findParentByType('container');
				            	Core.EventManager.fireEvent("nics.multiIncident.join", parent.items.items[0].getValue());
				            	Core.EventManager.fireEvent("map-window-clear");
				        	}
				}));

				return true;
			}
			else{
				
				var type = feature.get('type');		
				if(type) {
					container.add( new Ext.form.field.Display({
						fieldLabel: 'Type',
						value: type
					}));
				}
				
				var sym = feature.get('sym');		
				if(sym) {
					container.add( new Ext.form.field.Display({
						fieldLabel: 'Waypoint Symbol',
						value: sym
					}));
				}
				
				var desc = feature.get('description');
				if (desc) {
					var desc = new Ext.form.field.Display({
						fieldLabel: 'Description',
						labelAlign: 'top',
						value: desc
					});
					container.add( desc );
					
					//make all (non-mailto) links open in a new window
					desc.getEl().select("a:not([href^='mailto'])").set({"target" : "_blank"});
				}
			}
			return container.items.getCount() > 0;
		}
		
	});

});
